export default __webpack_public_path__ + "static/database-a8b18a5633825cd3c01558507e09cacb.svg";